import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Flex, Radio, Typography } from "@payping/web-components";
import { BankKhavarMianeh, BankSaman } from "@payping/icons";
import { Link, generatePath } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import classNames from "classnames";
import { ctaId } from "@/assets/googleTrackIds";
import { ReactNode, useEffect, useState } from "react";
import { BankTypeEnum } from "@payping/api";
import styles from "../../assets/scss/DigitalAccount/digital.module.scss";

interface ContentBank {
  title: string;
  icon: ReactNode;
  description: ReactNode;
}
const BankAccountCard = () => {
  const { t } = useAppTranslation();
  const availableBanks = useAppSelector((state) => state.digitalAccount.availableBanks);
  const [selectedBank, setSelectedBank] = useState<BankTypeEnum | undefined>();

  useEffect(() => {
    setSelectedBank(availableBanks[0]?.type);
  }, [availableBanks]);

  const renderContent: Record<BankTypeEnum, ContentBank> = {
    [BankTypeEnum.KhavarMiyane]: {
      title: t("settlement.bankName.Khavarmiane"),
      icon: (
        <div className="!tw-flex !tw-justify-center">
          <div
            className={classNames(
              styles.openingAccount_content,
              "background--gray100 tw-item-center !tw-flex !tw-justify-center",
            )}
          >
            <div
              className={classNames(
                styles.openingAccount_icon_content,
                "background--white !tw-flex !tw-justify-center",
              )}
            >
              <BankKhavarMianeh width={54} />
            </div>
          </div>
        </div>
      ),
      description: (
        <Typography.Text className={"!tw-flex !tw-justify-center tw-whitespace-pre-line"} type={"secondary"}>
          {t("digitalAccount.bankAccount.descKhavarmianeh")}
        </Typography.Text>
      ),
    },
    [BankTypeEnum.Saman]: {
      title: t("settlement.bankName.Saman"),
      icon: (
        <div className="!tw-flex !tw-justify-center">
          <div
            className={classNames(
              styles.openingAccount_content,
              "background--gray100 tw-item-center !tw-flex !tw-justify-center",
            )}
          >
            <div
              className={classNames(
                styles.openingAccount_icon_content,
                "background--white !tw-flex !tw-justify-center",
              )}
            >
              <BankSaman width={54} />
            </div>
          </div>
        </div>
      ),
      description: (
        <Typography.Text className={"!tw-flex !tw-justify-center tw-whitespace-pre-line"} type={"secondary"}>
          {t("digitalAccount.bankAccount.descSaman")}
        </Typography.Text>
      ),
    },
  };

  return (
    <Flex vertical gap={16}>
      <div className="!tw-flex !tw-justify-center">
        <Typography.Title level={4}>{t("digitalAccount.bankAccount.chooseTheBankYouWant")}</Typography.Title>
      </div>
      {selectedBank ? renderContent[selectedBank]?.icon : null}
      <Radio.Group
        onChange={(e) => setSelectedBank(e.target.value)}
        size={"middle"}
        className={"tw-flex tw-w-full tw-justify-center"}
        value={selectedBank}
      >
        {availableBanks.map((bank) => (
          <Radio.Button key={bank.type} value={bank.type}>
            {bank.type ? renderContent[bank.type].title : undefined}
          </Radio.Button>
        ))}
      </Radio.Group>
      {selectedBank ? renderContent[selectedBank]?.description : null}
      <div className="!tw-flex !tw-justify-center">
        {selectedBank ? (
          <Link
            to={
              selectedBank === BankTypeEnum.KhavarMiyane
                ? DashboardRoutes.digitalAccount.yourAccount.url
                : generatePath(DashboardRoutes.digitalAccount.agreement.url, { bank: BankTypeEnum[selectedBank] })
            }
          >
            <Button className="tw-w-fit tw-pl-8 tw-pr-8" type={"primary"} data-google-track={ctaId}>
              {t("start")}
            </Button>
          </Link>
        ) : null}
      </div>
    </Flex>
  );
};

export default BankAccountCard;
